import React, { useState } from 'react'
import Dropdown from '../../ui/Dropdwon'
import Button from '../../ui/Button'
import { FaEllipsisH } from 'react-icons/fa'
import OfferModal from '../../modal/Settings/OfferModal'
import useFetch from '../../../hooks/useFetch'
import { useSelector } from 'react-redux'
import { selectCid } from '../../../features/companyid'

const OfferActions = ({id}) => {
  
  const [openOfferModal, setOpenOfferModal] = useState(false);

  const cid = useSelector(selectCid);

  const { refetch } = useFetch("/v2/template/"+cid+"/duplicate/"+id,{
    method : "POST"
  },false);

  const { refetch : deleteTemp } = useFetch("/v2/template/delete/"+id+"/"+cid,{
    method : "DELETE"
  },false);

  return (
    <div>
    {
          openOfferModal &&  <OfferModal onClose={() => {setOpenOfferModal(false)}} isEdit={true} uuid={id}/>
    }
        <Dropdown trigger={<Button variant='icon' size='icon' className='border border-[#CFCFCF] rounded'>
            <FaEllipsisH />
        </Button> } 
            options={[
                {
                    label : "Edit Template",
                    onClick : () => setOpenOfferModal(true)
                },
                {
                    label : "Duplicate Template",
                    onClick : () => refetch().then(() => window.location.reload())
                },
                {
                    label : <div className='text-red-500'>Delete Template</div>,
                    onClick : () => deleteTemp().then(() => window.location.reload())
                }
            ]}
        />
    </div>
  )
}

export default OfferActions